export const networkMapContainer = 'networkMapContainer';


export interface district {
  code:string;
  id:number;
  lat:string|number;
  lng:string|number;
  name:string;
}
export interface mapInfo{
  city:any;
  district:any;
  level:number;
}

// 当前选中的行政区信息
export interface curSelectDistrictType {
  districtInfo :district[];
  cacheMapInfo:mapInfo|null;
}
export const creating = 'creating';
export const collecting = 'collecting';
export const allData = 'allData';
export const rankOptions:any[] = [
  // { key: creating, name: '生成中', value: creating },
  // { key: collecting, name: '收藏', value: collecting },
  { key: 'rank', name: '全部', value: allData },
  { key: 'rank20', name: '前20名', value: 20 },
  { key: 'rank50', name: '前50名', value: 50 },
  { key: 'rank100', name: '前100名', value: 100 },
  { key: 'rank200', name: '前200名', value: 200 },
  { key: 'rank300', name: '前300名', value: 300 },
  { key: 'rank500', name: '前500名', value: 500 },
];
export enum businessStatus {
  NEW = 'NEW',
  COMPLETE = 'COMPLETE'
}
// 筛选项枚举
export enum sectionKey {
  sortRule = 'sortRule', // 排名规则
  sortRuleMenu = 'sortRuleMenu', // 排名规则
  firstLevelCategory='firstLevelCategory', // 开店区域类型
  categoryMenu = 'categoryMenu', // 开店区域类型
  secondLevelCategoryCultureEducation='secondLevelCategoryCultureEducation', // 文教型
  secondLevelCategoryCommunity='secondLevelCategoryCommunity', // 社区型
  secondLevelCategoryTraffic='secondLevelCategoryTraffic', // 交通枢纽型
  secondLevelCategoryStreet='secondLevelCategoryStreet', // 街铺商圈型
  secondLevelCategoryOffice='secondLevelCategoryOffice', // 办公型
  secondLevelCategoryBusiness='secondLevelCategoryBusiness', // 商场型
  secondLevelCategoryScenicSpot='secondLevelCategoryScenicSpot', // 景区型
  secondLevelCategoryCompound='secondLevelCategoryCompound', // 复合型
  area = 'area', // 行政区--no,
  districtMenu = 'districtMenu', // 行政区--no,
  labelSystemMall = 'labelSystemMall', // 开店区域标签
  labelSystemHighQuality = 'labelSystemHighQuality', // 商圈特性
  preferBrand='preferBrand',
  preferBrandMenu = 'preferBrandMenu', // 偏好品牌--no
  avoidBrand = 'avoidBrand', // 避开品牌--no
  avoidBrandMenu = 'avoidBrandMenu', // 避开品牌--no
  caseBrandMenu = 'caseBrandMenu', // 案例品牌--no
  caseBrand = 'caseBrand', // 案例品牌--no
  cateringStore = 'cateringStore', // 餐饮门店数
  oldCateringStore = 'oldCateringStore', // 餐饮老店占比
  population = 'population', // 周边人口
  marketScore = 'marketScore', // 市场评分
  marketScoreMenu = 'marketScoreMenu', // 市场评分
  passFlow = 'passFlow', // 商场日均客流指数
  housePrice = 'housePrice', // 周边房屋均价
  facility='facility', // 周边配套（500m）
  workType ='workType', // 办公
  schoolType = 'schoolType', // 学校
  trafficType='trafficType', // 交通
  scenicType='scenicType', // 景区
  medicalType ='medicalType', // 医院
  otherType = 'otherType', // 其他市场
  households = 'households', // 小区户数
  houseYear = 'houseYear', // 小区建筑年代
  tourBrand='tourBrand', // 巡展品牌
  tourBrandMenu='tourBrandMenu', // 巡展品牌
  developerBrand='developerBrand', // 开发商品牌
  labelSystemSource='labelSystemSource', // 来源
  brand='brand', // 本品牌门店
  competitorBrand='competitorBrand', // 竞品品牌
  famousBrand='famousBrand', // 知名品牌
  collectArea='collectArea', // 收藏的开店区域
}

export const leftSection = [
  { label: '排名规则', code: 'sortRuleMenu', remark: '根据您的需求自定义排名规则',
    modules: [
      { label: '项目特性', code: 'sortRulePlace' },
      { label: '周边特性', code: 'sortRuleAround' }
    ]
  },
  { label: '项目', code: 'projectMenu',
    children: [
      { label: '行政区', code: 'area', remark: '筛选特定行政区域', },
      { label: '项目类型', code: 'placeCategory', remark: '筛选您所需要的项目类型' },
      { label: '项目定位', code: 'projectOrientation', remark: '筛选您所需要的项目定位' },
      { label: '项目规模', code: 'mallSize', remark: '筛选您所需要的项目规模' },
      { label: '开业时长', code: 'mallOpenYears', remark: '筛选您所需要的开业时长' },
      { label: '项目品牌', code: 'projectBrand', remark: '筛选您所需要的项目品牌' },
      { label: '项目客流', code: 'placeFlow', remark: '筛选您所需要的项目客流',
        modules: [
          { label: '市内客流对比', code: 'flowRank' },
          { label: '日均客流', code: 'dayFlow' },
          { label: '工作日客流', code: 'weekdayFlow' },
          { label: '节假日客流', code: 'weekendFlow' },
        ]
      },
    ]
  },
  { label: '点位', code: 'spotMenu',
    children: [
      { label: '点位类型', code: 'spotCategory', remark: '筛选您所需要的点位类型', },
      { label: '点位面积', code: 'spotArea', remark: '筛选您所需要的点位面积' },
      { label: '点位楼层', code: 'spotFloor', remark: '筛选您所需要的点位楼层' },
      { label: '点位客流', code: 'spotFlow', remark: '筛选您所需要的点位客流',
        modules: [
          { label: '日均客流', code: 'spotDayFlow' },
          { label: '工作日客流', code: 'spotWeekdayFlow' },
          { label: '节假日客流', code: 'spotWeekendFlow' },
        ]
      },
    ]
  },
  { label: '品牌与案例', code: 'brandMenu',
    children: [
      { label: '偏好品牌', code: 'preferBrand', remark: '查询周边500m有此品牌的项目', },
      { label: '避开品牌', code: 'avoidBrand', remark: '避开周边500m有此品牌的项目' },
      { label: '案例品牌', code: 'caseBrand', remark: '查询周边500m住宅特性符合要求的项目' },
    ]
  },
  { label: '周边特性', code: 'sortRulePlaceMenu',
    children: [
      { label: '住宅特性', code: 'houseCharacteristics', remark: '查询周边500m住宅特性符合要求的项目',
        modules: [
          { label: '户数', code: 'households' },
          { label: '房价', code: 'housePrice' },
          { label: '建筑年代', code: 'houseYear' },
        ]
      },
      { label: '周边配套', code: 'surrounding', remark: '查询周边500m内有此配套的项目',
        modules: [
          { label: '办公', code: 'workType' },
          { label: '学校', code: 'schoolType' },
          { label: '交通', code: 'trafficType' },
          { label: '景区', code: 'scenicType' },
          { label: '医院', code: 'medicalType' },
          { label: '其他市场', code: 'otherType' },
        ]
      },
    ]
  },
];

export const sortRuleAliasOptions = [
  { id: 1, name: '市场评分排序', key: 'marketScore' },
  { id: 2, name: '商场客流排序', key: 'mallPassFlow' },
  { id: 3, name: '餐饮门店排序', key: 'foodStores' },
  { id: 4, name: '餐饮老店排序', key: 'oldCateringRate' },
  { id: 5, name: '500米人口排序', key: 'population' },
  { id: 6, name: '3km人口排序', key: 'population3km' },
  { id: 7, name: '商场面积', key: 'polygonArea' },
  { id: 8, name: '商户数', key: 'openStores' },
  { id: 9, name: '建成年份', key: 'mallOpenYears' },
];
